import {
  categorySteps,
  colorSeq,
  locationSteps,
  Source,
  storeData,
  summary_notes,
} from "../../../utils/constant";
import DropDown from "../../elements/Dropdown";
import MultiselectDropdown from "../../elements/MultiselectDropdown";
import PieChartComponent from "../../elements/PieChart";
import StackedBarChart from "../../elements/StackedBarChart";
import StoreCard from "../../elements/StoreCard";
import styles from "./index.module.css";
import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import LineChart from "../../elements/LineChart";
import PriceChangeTable from "../../elements/PriceChangeTable";
import Header from "../../elements/Header";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDashboardAllDataAsyncThunk,
  fetchDashboardBrandAsyncThunk,
  fetchDashboardCategoryAsyncThunk,
  fetchDashboardDataAsyncThunk,
  fetchDashboardPriceRankAsyncThunk,
  fetchPriceChangeAsyncThunk,
  setDashboardAllData,
  setDashboardBrand,
  setDashboardCategory,
  setDashboardData,
  setDashboardPriceRank,
  setPieData,
  setPriceChange,
} from "../../../store/slices/Products/dashboard.slice";
import {
  fetchLivePriceChangeAsyncThunk,
  setDashboardLivePriceChange,
} from "../../../store/slices/Products/livePriceChange.slice";
import { useNavigate } from "react-router-dom";
import { Head, Row } from "../../elements/TableheadAndRow";
import Calendar from "react-calendar";
import { fetchAllTimeTrends } from "../../../store/slices/analytics/analytics.slice";
import PulseLoader from "react-spinners/PulseLoader";
import BeatLoader from "react-spinners/BeatLoader";
import AIBox from "../../elements/AIBox";
import {
  fetchAISummaryFromDataAsyncThunk,
  resetSummary,
} from "../../../store/slices/ai/ai.slice";

const prepareChartData = (priceChangeData) => {
  let LineChartData = [
    {
      label: "increased",
      data: [],
      borderColor: "#ff9999", // Pink color for line
      backgroundColor: "#ff9999", // Transparent pink for points
      borderWidth: 2,
      tension: 0.4,
      pointBackgroundColor: "#ff9999",
      pointBorderColor: "#fff",
      pointRadius: 5,
    },
    {
      label: "decreased",
      data: [],
      borderColor: "#A4D8C9", // Pink color for line
      backgroundColor: "#A4D8C9", // Transparent pink for points
      borderWidth: 2,
      tension: 0.4,
      pointBackgroundColor: "#A4D8C9",
      pointBorderColor: "#fff",
      pointRadius: 5,
    },
  ];

  priceChangeData.map((element) => {
    LineChartData[0].data.push(element.increased_count);
    LineChartData[1].data.push(element.decreased_count);
  });

  return LineChartData;
};

const prepareLineChartLabel = (priceChangeData) => {
  let dates = [];
  priceChangeData.map((element) => {
    let date = new Date(element.snapshot_date);
    dates.push(
      date.getDate() +
        "/" +
        (date.getMonth() + 1) +
        "/" +
        (date.getYear() - 100)
    );
  });

  return dates;
};

export const formatDate = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

const DfDashboard = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((store) => store.dashboard.loading);
  const dashboardData = useSelector((store) => store.dashboard);
  const { loadingLocation, source } = useSelector((store) => store.constant);
  const defaultDateRange = useSelector((store) => store.constant.date_range);
  const [timeTrendsData, setTimeTrendsData] = useState(-1);
  const timeTrends = useSelector((state) => state.analytics.timeTrends);
  const [dateToggle, setDateToggle] = useState({
    start: false,
    end: false,
  });
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [value, setValue] = useState({
    startValue: new Date(),
    endValue: new Date(),
  });
  const closeCalendar = useSelector((store) => store.toggleDropdown.calendar);

  useEffect(() => {
    const brand = {
      latest: {},
      past: {},
    };

    const product = {
      latest: {},
      past: {},
    };

    const tableData = [];

    for (let i = 0; i < timeTrends?.brands?.latest?.data.length; i++) {
      if (!brand.latest[timeTrends?.brands?.latest?.data[i]?.category])
        brand.latest[timeTrends?.brands?.latest?.data[i]?.category] = [
          timeTrends?.brands?.latest?.data[i],
        ];
      else
        brand.latest[timeTrends?.brands?.latest?.data[i]?.category]?.push(
          timeTrends?.brands?.latest?.data[i]
        );
    }

    for (let i = 0; i < timeTrends?.brands?.past?.data.length; i++) {
      if (!brand.past[timeTrends?.brands?.past?.data[i]?.category])
        brand.past[timeTrends?.brands?.past?.data[i]?.category] = [
          timeTrends?.brands?.past?.data[i],
        ];
      else
        brand.past[timeTrends?.brands?.past?.data[i]?.category]?.push(
          timeTrends?.brands?.past?.data[i]
        );
    }

    for (let i = 0; i < timeTrends?.products?.latest?.data.length; i++) {
      if (!product.latest[timeTrends?.products?.latest?.data[i]?.category])
        product.latest[timeTrends?.products?.latest?.data[i]?.category] = [
          timeTrends?.products?.latest?.data[i],
        ];
      else
        product.latest[timeTrends?.products?.latest?.data[i]?.category]?.push(
          timeTrends?.products?.latest?.data[i]
        );
    }

    for (let i = 0; i < timeTrends?.products?.past?.data.length; i++) {
      if (!product.past[timeTrends?.products?.past?.data[i]?.category])
        product.past[timeTrends?.products?.past?.data[i]?.category] = [
          timeTrends?.products?.past?.data[i],
        ];
      else
        product.past[timeTrends?.products?.past?.data[i]?.category]?.push(
          timeTrends?.products?.past?.data[i]
        );
    }

    let pc = 0,
      bc = 0,
      ppc = 0,
      bbc = 0;

    for (let i = 0; i < Object.keys(product?.latest)?.length; i++) {
      let latest = timeTrends?.priceranks?.latest?.find(
        (el) => el?.category == Object.keys(product?.latest)[i]
      );
      let past = timeTrends?.priceranks?.past?.find(
        (el) => el?.category == Object.keys(product?.latest)[i]
      );

      pc += product?.latest[Object.keys(product?.latest)[i]]?.length;
      bc += brand?.latest[Object.keys(product?.latest)[i]]?.length;
      ppc +=
        product?.latest[Object.keys(product?.latest)[i]]?.length -
        product?.past[Object.keys(product?.latest)[i]]?.length;
      bbc +=
        brand?.latest[Object.keys(product?.latest)[i]]?.length -
        brand?.past[Object.keys(product?.latest)[i]]?.length;
      tableData?.push({
        category: Object.keys(product?.latest)[i],
        product_count: product?.latest[Object.keys(product?.latest)[i]]?.length,
        product_count_chg:
          product?.latest[Object.keys(product?.latest)[i]]?.length -
          product?.past[Object.keys(product?.latest)[i]]?.length,
        brand_count: brand?.latest[Object.keys(product?.latest)[i]]?.length,
        brand_count_chg:
          brand?.latest[Object.keys(product?.latest)[i]]?.length -
          brand?.past[Object.keys(product?.latest)[i]]?.length,
      });
    }

    tableData?.push({
      category: "all",
      product_count: pc,
      brand_count: bc,
      product_count_chg: ppc,
      brand_count_chg: bbc,
    });

    setTimeTrendsData(tableData);
  }, [timeTrends]);

  // Get price trends.
  useEffect(() => {
    if (dateRange.start && dateRange.end) {
      dispatch(
        fetchAllTimeTrends({
          past_date: dateRange?.start,
          latest_date: dateRange?.end,
          source,
        })
      );
    }
  }, [dateRange, source]);

  // Get all the data for the dashboard.
  const getAllData = async () => {
    const response = await dispatch(
      fetchDashboardAllDataAsyncThunk({
        source,
        offset: 0,
        limit: 10,
        category: categorySteps.join(",").toLowerCase(),
        brand: null,
        location:
          dashboardData.selLocation.join(",").toLowerCase() +
          `${dashboardData.selLocation.length ? `,${source}` : source}`,
      })
    );
    if (response.payload.status === "success") {
      dispatch(setDashboardAllData(response.payload));
      dispatch(setPieData(response.payload.stats));
      dispatch(
        fetchAISummaryFromDataAsyncThunk({
          data: response.payload?.ai,
          notes: summary_notes?.replace("%source%", source),
        })
      );
    }
  };
  const timer = useRef(null);
  const debounce = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      getAllData();
    }, 600);
  };

  useEffect(() => {
    if (locationSteps.length > 7 && dashboardData && !loadingLocation) {
      debounce();
    }

    return () => {
      dispatch(resetSummary());
    };
  }, [dashboardData.selLocation, source]);

  const getPriceChange = async () => {
    const response = await dispatch(
      fetchPriceChangeAsyncThunk({ page: "dashboard", parameters: {} })
    );
    if (response.payload.status === "success") {
      dispatch(setPriceChange(response.payload.data));
    }
  };

  useEffect(() => {
    if (dashboardData?.priceChange == -1) {
      getPriceChange();
    }
  }, [source]);

  // Reset date toggle when calendar is closed
  useEffect(() => {
    setDateToggle({ start: false, end: false });
  }, [closeCalendar]);

  // Handle date range selection
  const handleDateRange = (selectedDate) => {
    const formattedDate = formatDate(selectedDate);

    if (dateToggle.start) {
      setValue({ ...value, startValue: selectedDate });
      setDateRange({ ...dateRange, start: formattedDate });
    }

    if (dateToggle.end) {
      setValue({ ...value, endValue: selectedDate });
      setDateRange({ ...dateRange, end: formattedDate });
    }

    setDateToggle({ start: false, end: false });
  };

  // Set the default date range
  useEffect(() => {
    if (Object.keys(defaultDateRange).length > 0) {
      setValue({
        startValue: new Date(defaultDateRange.min_date),
        endValue: new Date(defaultDateRange.max_date),
      });
      setDateRange({
        start: formatDate(new Date(defaultDateRange.min_date)),
        end: formatDate(new Date(defaultDateRange.max_date)),
      });
    }
  }, [defaultDateRange]);

  const handleStatsNavigation = (filter) => {
    navigate(
      `/dashboard/df-products?pricerange=${filter}&location=${dashboardData.selLocation}`
    );
  };

  return (
    <div className={styles["container"]}>
      <Header isDashboard={true} />
      <hr />
      {/* <div className={styles["ai_box"]}> */}
        {/* <AIBox isExpand={false} areTables={true} /> */}
      {/* </div> */}
      <div className={styles["stats"]}>
        {/* <div className={styles["box"]}>
          <div className={styles["label"]}>Price Rank</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {dashboardData?.priceRank?.data}
            </div>
      
          </div>
        </div> */}
        <div
          className={styles["box"]}
          onClick={() => navigate("/dashboard/df-products")}
        >
          <div className={styles["label"]}>Products</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {loading || loadingLocation ? (
                <PulseLoader size={10} />
              ) : (
                dashboardData.dashboard?.productCount
              )}
            </div>
            {/* <div className={styles["change"] + " " + styles["up"]}>
              <div>-</div>
              <div><i class="bi bi-arrow-up-right"></i></div>
            </div> */}
          </div>
        </div>
        <div className={styles["box"]}>
          <div className={styles["label"]}>Brands</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {loading || loadingLocation ? (
                <PulseLoader size={10} />
              ) : (
                dashboardData.dashboard?.brands
              )}
            </div>
            {/* <div className={styles["change"] + " " + styles["down"]}>
              <div>-</div>
              <div>
                <i class="bi bi-arrow-down-right"></i>
              </div>
            </div> */}
          </div>
        </div>
        <div className={styles["box"]}>
          <div className={styles["label"]}>Categories</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {loading || loadingLocation ? (
                <PulseLoader size={10} />
              ) : (
                dashboardData.dashboard?.categories
              )}
            </div>
            {/* <div className={styles["change"] + " " + styles["up"]}>
              <div>- </div>
              <div>
                <i class="bi bi-arrow-up-right"></i>
              </div>
            </div> */}
          </div>
        </div>
        <div
          className={styles["box"]}
          onClick={() => handleStatsNavigation("cheapest")}
        >
          <div className={styles["label"]}>Cheapest Products</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {loading || loadingLocation ? (
                <PulseLoader size={10} />
              ) : (
                dashboardData.dashboard?.cheapestProducts
              )}
            </div>
            {/* <div className={styles["change"] + " " + styles["down"]}>
              <div>-</div>
              <div>
                <i class="bi bi-arrow-down-right"></i>
              </div>
            </div> */}
          </div>
        </div>
        <div
          className={styles["box"]}
          onClick={() => handleStatsNavigation("midrange")}
        >
          <div className={styles["label"]}>Midrange Products</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {loading || loadingLocation ? (
                <PulseLoader size={10} />
              ) : (
                dashboardData.dashboard?.midrangeProducts
              )}
            </div>
            {/* <div className={styles["change"] + " " + styles["up"]}>
              <div>-</div>
              <div>
                <i class="bi bi-arrow-up-right"></i>
              </div>
            </div> */}
          </div>
        </div>
        <div
          className={styles["box"]}
          onClick={() => handleStatsNavigation("expensive")}
        >
          <div className={styles["label"]}>Expensive Products</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {loading || loadingLocation ? (
                <PulseLoader size={10} />
              ) : (
                dashboardData.dashboard?.expensiveProducts
              )}
            </div>
            {/* <div className={styles["change"] + " " + styles["down"]}>
              <div>-</div>
              <div>
                <i class="bi bi-arrow-down-right"></i>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <hr />
      <div className={styles["row"]}>
        <div className={styles["tcompare"]}>
          <div className={styles["tcompare_top"]}>
            <div className={styles["tcompare_head"]}>
              <div>Compare prices per category</div>
            </div>
            <div className={styles["tcompare_sub"]}>
              <div className={styles["tcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#A4D8C9" }}></span>
                </div>
                <div>cheapest</div>
              </div>
              <div className={styles["tcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#ffffb7" }}></span>
                </div>
                <div>midrange</div>
              </div>
              <div className={styles["tcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#ff9999" }}></span>
                </div>
                <div>expensive</div>
              </div>
            </div>
          </div>
          <div className={styles["tcompare_bottom"]}>
            <StackedBarChart
              url={"/dashboard/df-products"}
              data={loading ? [] : dashboardData?.category}
              blueLabel={"cheapest_count"}
              greyLabel={"midrange_count"}
              greenLabel={"expensive_count"}
              type={"category"}
              location={dashboardData.selLocation}
            />
          </div>
        </div>
        <div className={styles["distribution"]}>
          <div className={styles["filters"]}>
            {/* <div className={styles["dropdown"]}>
              <DropDown
                steps={typeSteps}
                selectedValue={sortingSelected.category}
                onChange={onSortingSelectedChangeCategory}
              />
            </div> */}
            <div
              className={styles["button"]}
              onClick={() =>
                navigate("/dashboard/analytics", {
                  state: { tab: 1 },
                })
              }
            >
              View More
            </div>
          </div>
          <div className={styles["dist_card"]}>
            <div className={styles["dist_head"]}>Overall Price Comparison</div>
            <div className={styles["dist_pie"]}>
              <div>
                <PieChartComponent
                  data={loading ? [] : dashboardData.pieData}
                  url={"/dashboard/df-products"}
                  customParam={"label"}
                  location={dashboardData.selLocation}
                  // showLabels={false}
                  showLegend={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles["row"]}>
        <div className={styles["pbcompare"]}>
          <div className={styles["pbcompare_top"]}>
            <div className={styles["pbcompare_head"]}>
              <div>Compare prices per brand</div>
            </div>
            <div className={styles["pbcompare_sub"]}>
              <div className={styles["pbcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#A4D8C9 " }}></span>
                </div>
                <div>cheapest</div>
              </div>
              <div className={styles["pbcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#ffffb7" }}></span>
                </div>
                <div>midrange</div>
              </div>
              <div className={styles["pbcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#ff9999" }}></span>
                </div>
                <div>expensive</div>
              </div>
            </div>
            <div className={styles["pb_filters"]}>
              {/* <div className={styles["dropdown"]}>
                <DropDown
                  steps={typeSteps}
                  selectedValue={sortingSelected.brand}
                  onChange={onSortingSelectedChange}
                />
              </div> */}
              <div
                className={styles["button"]}
                onClick={() =>
                  navigate("/dashboard/analytics", {
                    state: { tab: 2 },
                  })
                }
              >
                View More
              </div>
            </div>
          </div>
          <div className={styles["pbcompare_bottom"]}>
            <div
              style={{
                width:
                  dashboardData.brand.length > 0 &&
                  `calc(20% * ${dashboardData.brand.length})`,
              }}
            >
              <StackedBarChart
                url={"/dashboard/df-products"}
                data={loading ? [] : dashboardData.brand}
                blueLabel={"cheapest_count"}
                greyLabel={"midrange_count"}
                greenLabel={"expensive_count"}
                type={"brand"}
                location={dashboardData.selLocation}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles["row"]}>
        <div className={styles["pcompare"]}>
          <div className={styles["pcompare_top"]}>
            <div className={styles["pcompare_head"]}>
              <div>When Price Changes Mostly Happen</div>
            </div>
            <div className={styles["pcompare_sub"]}>
              <div>
                <div className={styles["pcompare_section"]}>
                  <div>
                    <span style={{ backgroundColor: "#ff9999" }}></span>
                  </div>
                  <div>increased</div>
                </div>
                <div className={styles["pcompare_section"]}>
                  <div>
                    <span style={{ backgroundColor: "#A4D8C9" }}></span>
                  </div>
                  <div>decreased</div>
                </div>
              </div>
              <div
                className={styles["button"]}
                onClick={() =>
                  navigate("/dashboard/analytics", {
                    state: { tab: 3 },
                  })
                }
              >
                View More
              </div>
            </div>
          </div>
          <div className={styles["pcompare_bottom"]}>
            <LineChart
              data={
                dashboardData?.priceChange != -1
                  ? prepareChartData(dashboardData?.priceChange)
                  : []
              }
              labels={
                dashboardData?.priceChange != -1
                  ? prepareLineChartLabel(dashboardData?.priceChange)
                  : []
              }
            />
          </div>
        </div>
      </div>

      {/* <div className={styles["row"]}>
        <div className={styles["lcompare"]}>
          <div className={styles["lcompare_top"]}>
            <div className={styles["lcompare_head"]}>
              <div>Live Price Changes</div>
            </div>
            <div className={styles["l_filters"]}>
              <div
                className={styles["button"]}
                onClick={() => navigate("/dashboard/live-monitoring")}
              >
                View More
              </div>
            </div>
          </div>
          <div className={styles["lcompare_bottom"]}>
            <PriceChangeTable
              data={priceChangeData != -1 ? priceChangeData : []}
            />
          </div>
        </div>
      </div> */}

      {/* Time trends */}
      {/* <div className={styles["time-trends-heading"]} style={{}}>
        <div>
          <h3>Period Based Analysis</h3>
          <span>Track how your stats change over time.</span>
        </div>

        <div className={styles["dateRange"]}>
          <span>Date Range</span>
          <div className={styles["dates"]}>
            <div
              className={styles["start"]}
              onClick={(e) => {
                e.stopPropagation();
                setDateToggle({ start: !dateToggle.start, end: false });
              }}
            >
              <input type="text" defaultValue={dateRange.start} readOnly />
              <i class="bi bi-calendar-date"></i>
            </div>
            <div
              className={styles["end"]}
              onClick={(e) => {
                e.stopPropagation();
                setDateToggle({ start: false, end: !dateToggle.end });
              }}
            >
              <input type="text" defaultValue={dateRange.end} readOnly />
              <i class="bi bi-calendar-date"></i>
            </div>
          </div>
          {dateToggle.start && (
            <div
              className={styles["calendar"]}
              onClick={(e) => e.stopPropagation()}
            >
              <Calendar
                value={value.startValue}
                onChange={(e) => handleDateRange(e)}
              />
            </div>
          )}

          {dateToggle.end && (
            <div
              className={styles["calendar"]}
              onClick={(e) => e.stopPropagation()}
            >
              <Calendar
                value={value.endValue}
                onChange={(e) => handleDateRange(e)}
              />
            </div>
          )}
        </div>
      </div> */}

      {/* <div className={styles["categoryTable"]}>
        <Head>
          <span>Category</span>
          <span>Brands</span>
          <span>Chg</span>
          <span>Products</span>
          <span>Chg</span>
        </Head>
        {timeTrendsData == -1 ? (
          <div className="loader-container">
            <BeatLoader />
          </div>
        ) : (
          timeTrendsData?.map((item, index) => (
            <Row
              key={index}
              islast={timeTrendsData?.length - 1 == index ? true : false}
            >
              <span>{item.category}</span>
              <span>{item.brand_count}</span>
              <span>
                {Math.abs(item.brand_count_chg || 0)}{" "}
                {item.brand_count_chg !== null &&
                  (item.brand_count_chg > 0 == "up" ? (
                    <i className={`bi bi-caret-up-fill ${styles["up"]}`}></i>
                  ) : (
                    <i
                      className={`bi bi-caret-down-fill ${styles["down"]}`}
                    ></i>
                  ))}
              </span>
              <span>{item.product_count}</span>
              <span>
                {Math.abs(item.product_count_chg || 0)}{" "}
                {item.product_count_chg !== null &&
                  (item.product_count_chg > 0 == "up" ? (
                    <i className={`bi bi-caret-up-fill ${styles["up"]}`}></i>
                  ) : (
                    <i
                      className={`bi bi-caret-down-fill ${styles["down"]}`}
                    ></i>
                  ))}
              </span>
            </Row>
          ))
        )}
      </div> */}
    </div>
  );
};

export default DfDashboard;
